import React from 'react';
import { Button, Container, Grid, Icon, Segment } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import {
  pageBodyStyle,
  pageFrameStyle,
  pageShellStyle,
  sectionTitleStyle,
  surfaceCardStyle,
} from '../misc/pageStyles';
import AccountImportCard from '../account/AccountImportCard';

const channelCards = [
  {
    key: 'discover',
    title: 'Buscar publicaciones nuevas',
    description:
      'Encontrá publicaciones creadas recientemente y agregalas a MercuryCom con la estrategia de importación adecuada.',
    cta: 'Buscar nuevas publicaciones',
    to: '/notifications',
    icon: 'search',
  },
  {
    key: 'accounts',
    title: 'Cuentas conectadas',
    description:
      'Revisá sellers, permisos y estado de conexión de cada canal antes de volver a importar o sincronizar.',
    cta: 'Gestionar cuentas',
    to: '/newAccount',
    icon: 'plug',
  },
];

function ChannelsPage() {
  return (
    <Container fluid style={pageShellStyle}>
      <Segment style={pageFrameStyle}>
        <div style={pageBodyStyle}>
          <div style={sectionTitleStyle}>Flujos disponibles</div>
          <Grid stackable columns={3}>
            <Grid.Column>
              <AccountImportCard
                description="Leé las publicaciones actuales de Mercado Libre o Tienda Nube para agruparlas por SKU y dejar tu base ordenada."
              />
            </Grid.Column>
            {channelCards.map((card) => (
              <Grid.Column key={card.key}>
                <Segment style={{ ...surfaceCardStyle, padding: 20, height: '100%' }}>
                  <div
                    style={{
                      width: 42,
                      height: 42,
                      borderRadius: 14,
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: '#F5EDFF',
                      color: '#7C3AED',
                      marginBottom: 14,
                    }}
                  >
                    <Icon name={card.icon} style={{ margin: 0 }} />
                  </div>
                  <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 8 }}>{card.title}</div>
                  <div style={{ color: '#6B7280', lineHeight: 1.6, minHeight: 72, marginBottom: 16 }}>
                    {card.description}
                  </div>
                  <Button as={Link} to={card.to} basic color="violet">
                    {card.cta}
                  </Button>
                </Segment>
              </Grid.Column>
            ))}
          </Grid>
        </div>
      </Segment>
    </Container>
  );
}

export default ChannelsPage;

